import React from 'react'
import ForPatientsSection from '../../ForPatientsSection/ForPatientsSection'
import Navbar from '../../LandingPage/Navbar/Navbar'
import Footer2 from '../../Footer2/Footer2'
import TopBar from '../../EdofSectionNew2/TopBar/TopBar'
const ForPatients = () => {
    return (
        <div>
            <TopBar/>
            <Navbar />
            <ForPatientsSection />
            <Footer2 />

        </div>
    )
}

export default ForPatients
